




























import Vue from 'vue'
import Component from 'vue-class-component'
import ResultPage from '@app/componentlib/src/views/job-match/result-page/ResultPage.vue'
import Favorites from '@app/componentlib/src/views/components/job-components/Favorites.vue'
import DeepLinkResult from '@app/componentlib/src/views/components/job-components/DeepLinkResult.vue'
import HeartEmptyFull from '@app/componentlib/src/views/components/HeartEmptyFull.vue'

import { IResultPage } from '@app/componentlib/common/types/JobMatchTypes'
import { ISettingsItem } from '@app/componentlib/common/types/JobSearchTypes'
import { SavedAdvertsModule } from '@app/componentlib/src/store/modules/JobMatch/savedAdverts'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch'

@Component<JobMatchResultContainer>({
  props: {
    content: Object,
    settings: Object,
    jobApplicationAccess: Boolean
  },
  components: {
    ResultPage,
    Favorites,
    DeepLinkResult,
    HeartEmptyFull,
  }
})

export default class JobMatchResultContainer extends Vue {
  /**
   * Props variables
   */
  content: IResultPage | undefined
  settings: ISettingsItem | undefined
  jobApplicationAccess: boolean | undefined


  /**
   * Component state variables
   */
  tabType: string = 'jobmatch'

  /**
   * Lifecycle
   */

  mounted () {
    AppModule.setIsMobile(window.innerWidth)

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })

    SavedAdvertsModule.getSavedAdverts()
  }

  unmounted () {
    window.removeEventListener('resize', this.onResize)
  }


  /**
   * Getters
   */
  get count () {
    return SavedAdvertsModule.count
  }

  get loadingAdverts () {
    return SavedAdvertsModule.loading
  }

  get t (): any {
    return AppModule.translations
  }

  get deepLinkJobId (): number {
    return JobMatchModule.deepLinkJobId
  }

  /**
   * Methods
   */
  onResize (e: any) {
    if (e.currentTarget.innerWidth <= 768) {
      JobMatchModule.setSelectedJobPosting(undefined)
      SavedAdvertsModule.setSelectedJobPosting(undefined)
      JobMatchModule.setResizeDoneDesktop(false)
      JobMatchModule.setShowAllOccupations(false)
    } else if (e.currentTarget.innerWidth > 768) {
      //There is no need to reset active indexes when resizing windows larger than mobile.
      if (JobMatchModule.resizeDoneDesktop === false) {
        JobMatchModule.setActiveIndex(0)
        SavedAdvertsModule.setActiveIndex(0)

        SavedAdvertsModule.setSelectedJobPosting(SavedAdvertsModule.savedAdverts !== undefined ? SavedAdvertsModule.savedAdverts[0] : undefined)

        if (this.deepLinkJobId !== 0) {
          JobMatchModule.setSelectedJobPosting(JobMatchModule.advert !== undefined ? JobMatchModule.advert : undefined)
        } else {
          JobMatchModule.setSelectedJobPosting(JobMatchModule.jobPostings !== undefined ? JobMatchModule.jobPostings[0] : undefined)
        }

        JobMatchModule.setResizeDoneDesktop(true)

        JobMatchModule.setShowAllOccupations(true)
      }
    }

    AppModule.setIsMobile(e.currentTarget.innerWidth)
  }

  disableSearchForMore (value: boolean) {
    SavedAdvertsModule.setDisableSearchForMore(value)
  }

  changeTab (type: string) {
    JobMatchModule.setDeepLinkJobId(0)
    this.tabType = type
  }
}
